/* ============================================================
   FRESSENCES — los dos efectos que comparten todas las páginas.

   En los prototipos esto lo hacía GSAP + ScrollTrigger (dos librerías,
   ~120 KB). Aquí caben en cincuenta líneas con IntersectionObserver, y de
   paso no hay una dependencia externa que, si no carga, deje media página
   en blanco.

   Se usa poniendo atributos en el HTML:

     data-fr-rv       el elemento entra con un fundido al llegar a pantalla
     data-fr-barras   dentro, los [data-w] se llenan hasta su ancho al entrar

   Los estilos de `.fr-rv` están en fressences.css.
   ============================================================ */
(function () {
  var REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------- Reveals ---------- */
  function reveals() {
    var todos = document.querySelectorAll('[data-fr-rv]');
    if (!todos.length) return;

    // Sin observador o con "reducir movimiento": se ve todo, y ya está.
    if (REDUCE || !('IntersectionObserver' in window)) return;

    var ojo = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('fr-rv--on');
        ojo.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });

    todos.forEach(function (el) {
      el.classList.add('fr-rv');
      ojo.observe(el);
    });

    // Red de seguridad: un reveal que no dispara deja media página en blanco,
    // y eso es peor que no tener animación. A los 4 segundos se enciende todo.
    setTimeout(function () {
      todos.forEach(function (el) { el.classList.add('fr-rv--on'); });
    }, 4000);
  }

  /* ---------- Barras de las comparativas ---------- */
  function barras() {
    document.querySelectorAll('[data-fr-barras]').forEach(function (caja) {
      var trozos = caja.querySelectorAll('[data-w]');
      if (!trozos.length) return;

      function llena() {
        trozos.forEach(function (f, k) {
          if (REDUCE) {
            f.style.transition = 'none';
            f.style.width = f.dataset.w;
          } else {
            // escalonadas: se leen como una lectura, no como un parpadeo
            setTimeout(function () { f.style.width = f.dataset.w; }, k * 130);
          }
        });
      }

      if (!('IntersectionObserver' in window)) { llena(); return; }
      // Dispara por POSICIÓN, no por área: la caja mide más que la pantalla en
      // monitores bajos y un umbral por ratio no se cumpliría nunca.
      new IntersectionObserver(function (en, ob) {
        if (en[0].isIntersecting) { llena(); ob.disconnect(); }
      }, { rootMargin: '0px 0px -18% 0px', threshold: 0 }).observe(caja);
    });
  }

  function arranca() { reveals(); barras(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }
})();
